import React from 'react';
import FixedBottomBanner from './FixedBottomBanner';
import useAppSelector from '../app/redux/useAppSelector';
import Link from '../utils/router/Link';

const useMessage = () => {
  const { billingStatus, isLocked, isTrialEnded, isTrialEndingSoon } =
    useAppSelector((state) => state.session.organization);
  const type = useAppSelector((state) => state.session.user.type);
  const isAdmin = type === 'ADMIN';

  if (!isAdmin) {
    if (isLocked && isTrialEnded) {
      return 'Your trial has ended and Slab is now read-only. Please contact an admin to upgrade.';
    }

    if (billingStatus === 'CANCELED') {
      return 'Your subscription to Slab has been canceled. You can contact an admin to reactivate your subscription at any time.';
    }

    return null;
  }

  if (isTrialEndingSoon) {
    return (
      <>
        Your trial is ending soon. Please{' '}
        <Link to="/admin/billing">upgrade now</Link>.
      </>
    );
  }

  if (isLocked && isTrialEnded) {
    return (
      <>
        Your trial has ended and Slab is now read-only. Please{' '}
        <Link to="/admin/billing">upgrade now</Link>.
      </>
    );
  }

  if (billingStatus === 'CANCELED') {
    return (
      <>
        Your subscription to Slab has been canceled. You can{' '}
        <Link to="/admin/billing">reactivate your subscription</Link> at any
        time.
      </>
    );
  }

  if (billingStatus === 'PAST_DUE') {
    return (
      <>
        Your subscription payment failed. We&apos;ll retry payment. You can{' '}
        <Link to="/admin/billing">review your payment settings</Link>.
      </>
    );
  }

  if (billingStatus === 'UNPAID') {
    return (
      <>
        Your subscription payment failed. Please{' '}
        <Link to="/admin/billing">review your payment settings</Link>.
      </>
    );
  }

  return null;
};

const BillingBanner = () => {
  const message = useMessage();
  const { billingStatus, isTrialEnded } = useAppSelector(
    (state) => state.session.organization,
  );

  return (
    message && (
      <FixedBottomBanner
        variant={
          isTrialEnded || billingStatus === 'UNPAID' ? 'danger' : 'warning'
        }
      >
        {message}
      </FixedBottomBanner>
    )
  );
};

BillingBanner.useIsActive = () => !!useMessage();

export default BillingBanner;
